export const METRIC_TIERS = {
  cheap: [
    'total_vehicles', 'avg_vehicle_age',
    'lifetime_fleet_tco', 'tco_per_vehicle', 'tco_per_mile',
    'percent_vehicles_down', 'wo_open_count',
    'percent_scheduled_wos', 'avg_cost_per_wo',
    'percent_vehicles_inspected',
    'fuel_consumption_rate', 'fuel_cost',
    'fuel_cost_per_vehicle', 'fuel_quantity',
    'oldest_vehicles', 'current_odometer_vehicles',
  ],
  medium: [
    'vehicle_utilization_rate', 'driver_utilization_rate',
    'cumulative_downtime_hours',
    'fuel_cost_trend', 'fuel_quantity_trend',
    'vehicle_utilization_rate_trend', 'driver_utilization_rate_trend',
    'lifetime_fleet_tco_trend',
    'percent_vehicles_down_trend', 'wo_open_count_trend',
    'percent_scheduled_wos_trend', 'avg_cost_per_wo_trend',
    'cumulative_wo_count', 'repair_reason_breakdown',
    'vehicles_down_per_day', 'vehicles_not_inspected_trend',
    'highest_spend_vehicles', 'fillup_count_vehicles', 'worst_mpg_vehicles',
    'highest_spend_drivers', 'fillup_count_drivers', 'worst_mpg_drivers',
    'wos_per_vehicle_per_month', 'labor_hours_per_technician',
    'downtime_hours_per_vehicle',
    'operating_cost', 'operating_cost_per_mile',
  ],
  heavy: [
    'highest_tco_vehicles',
    'worst_tco_per_mile_vehicles',
    'worst_operating_cost_per_mile',
    'operating_cost_trend',
  ],
};

// Quick O(1) tier lookup per route. Unknown routes fall back to 'medium'.
export const TIER_OF = Object.fromEntries(
  Object.entries(METRIC_TIERS).flatMap(([tier, routes]) =>
    routes.map((r) => [r, tier])
  )
);
